// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useFaqApi } from '../../hooks/useFaqApi';

export const useCreateFaq = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createFaq } = useFaqApi();
  return useMutation({
    mutationKey: ['CreateFaq'],
    mutationFn: (data: any) => createFaq(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'DeliveryManager created successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getFaqs'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create DeliveryManager',
        'error'
      );
    },
  });
};

export const useBlockUnblockFaqs = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getBlockUnblockFaq } = useFaqApi();

  return useMutation({
    mutationKey: ['Block/UnblockFaqs'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getBlockUnblockFaq({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`FAQ ${action} successfully`, 'success');

      queryClient.invalidateQueries({
        queryKey: ['getFaqs'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type || 'Failed to block the Faq',
        'error'
      );
    },
  });
};

export const useDeleteFaqs = () => {
  const queryClient = useQueryClient();
  const { getDeleteFaqs } = useFaqApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteFaqs'],
    mutationFn: (ids: string[]) => {
      return getDeleteFaqs(ids);
    },
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Faq deleted successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getFaqs'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted Faq',
        'error'
      );
    },
  });
};

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useGetAllFaqs = (queryParams: Params) => {
  const { getAllFAQs } = useFaqApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: [
      'getFaqs',
     queryParams
    ],
    queryFn: () => {
      return getAllFAQs(queryParams);
    },
  });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};

export const useEditFaqs = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getEditFaqs } = useFaqApi();

  return useMutation({
    mutationKey: ['EditFaqs'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      getEditFaqs(id, data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Faq Updated successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getFaqs'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type || 'Failed to update the Faq',
        'error'
      );
    },
  });
};
